<template>
    <div class="max-w-[1024px] text-gray-700">
        <div v-if="isLoading" class="flex flex-col justify-center items-center h-64">
            <div class="w-full flex justify-center items-center">
                Please wait while we update your profile.
            </div>
            <div class="w-12 h-12 py-8">
                <LoadingSpinner />
            </div>
        </div>
        <form v-else @submit.prevent="uploadImages" action="">
            <div class="space-y-4 pb-6">
                <p>Thank you for your willingness to share your photographs with Shedd Capital, LLC!</p>
                <p>We are excited to showcase the incredible talent of our alumni on our website and in promotional materials. We ask that you only upload photographs that are appropriate for the workplace.</p>
                <div class="w-full flex flex-col space-y-4 text-gray-100">
                    <label for="fileInput" class="text-gray-700">Upload Photos:</label>
                    <input
                        @change="processUserPhotos"
                        name="fileInput"
                        id="fileInput"
                        type="file"
                        accept=".png, .jpg, .jpeg, .svg"
                        class="text-sm"
                        multiple
                    />
                    <div v-if="selectedUserPhotos.length > 0" class="text-gray-700 space-y-2">
                        <div>{{ selectedUserPhotos.length }} Selected Photos:</div>
                        <ul class="space-y-2">
                            <li class="w-full px-3 py-2 border rounded-md border-gray-300 hover:text-indigo-700 hover:bg-indigo-50 cursor-pointer" @click=removeSelectedPhoto(index) v-for="(photo, index) in selectedUserPhotos" :key="index">
                                {{ photo.name }}
                            </li>
                        </ul>
                    </div>
                    <p class="text-gray-700">After uploading, please submit your consent for use in the 'Photo Consent' section. If you have already provided consent to Shedd Capital, any new photos you upload will automatically be included in your previous agreement.</p>
                </div>
            </div>
            <div class="w-full pt-6 border-t border-gray-300">
                <button
                    type="submit"
                    :disabled="!validForm"
                    class="px-4 py-3 bg-dark-primary text-white font-semibold leading-tight rounded-md transition duration-150 ease-in-out w-full"
                    :class="{ 'hover:bg-[#181B4E] hover:shadow-md focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg' : validForm, 'opacity-50' : !validForm}"
                >
                    Upload Photos
                </button>

            </div>
        </form>
    </div>
</template>

<script setup>
import { ref, computed, defineEmits } from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'vue-toast-notification';
import { createUserImages } from '@/services/User';
import { pageVisitLogger} from '@/composables/PageVisitLogging';
import LoadingSpinner from '../base-components/LoadingSpinner.vue';

const store = useStore()
const $toast = useToast()

const emit = defineEmits('get-user-images')

const { navigateToPage } = pageVisitLogger()

const isLoading = ref(false)
const selectedUserPhotos = ref([]);

function processUserPhotos(event) {
    if (event.target.files && event.target.files[0]) {
        selectedUserPhotos.value = Array.from(event.target.files);
    }
    const fileInput = document.getElementById('fileInput')
    fileInput.value = ''
}

function removeSelectedPhoto(photoIndex) {
    selectedUserPhotos.value.splice(photoIndex, 1)
}

const validForm = computed(() => {
    return selectedUserPhotos.value.length > 0 ? true : false
})

async function uploadImages() {
    isLoading.value = true
    const token = store.state.auth.token
    const formData = new FormData()
    selectedUserPhotos.value.forEach(file => {
        formData.append('images', file)
    })
    const response = await createUserImages(token, formData)
    if(response.status == 201) {
        $toast.open({
            type: 'success',
            message: 'Successfully uploaded images.',
            duration: 5000
        })
        selectedUserPhotos.value = []
        emit('get-user-images')
        navigateToPage('/profile/photo-consent', 'Photo Consent')
    } else {
        $toast.open({
            type: 'error',
            message: 'Error while uploading images.',
            duration: 10000
        })
    }
    isLoading.value = false
}
</script>